import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ama_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ama_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("ama_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("ama_token");
        localStorage.removeItem("ama_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ama_token", r.data.access_token);
    localStorage.setItem("ama_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const refreshMe = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    localStorage.setItem("ama_user", JSON.stringify(r.data));
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("ama_token");
    localStorage.removeItem("ama_user");
    setUser(null);
    window.location.href = "/login";
  };

  const hasRole = (...roles) => {
    if (!user) return false;
    if (user.roles?.includes("administrator")) return true;
    return roles.some((r) => user.roles?.includes(r));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasRole, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
